<template>
  <div>
    <bell-outline-icon v-if="outlineIcon" />
    <bell-icon v-else />

    <span
      v-if="unseenCount"
      class="notification-bell"
    >
      <template v-if="unseenCount < 100">
        {{ unseenCount }}
      </template>
      <template v-else>
        99+
      </template>
    </span>
  </div>
</template>

<script>
export default {
  props: {
    outlineIcon: {
      type: Boolean,
      required: false,
      default: true,
    },
    unseenCount: { type: Number, required: false, default: 0 },
  },
};
</script>

<style lang="scss" scoped>
  div {
    display: inline-block;
    position: relative;
  }
</style>
